import { render, staticRenderFns } from "./BadgeButton.vue?vue&type=template&id=11ab8ae3&scoped=true"
import script from "./BadgeButton.vue?vue&type=script&lang=js"
export * from "./BadgeButton.vue?vue&type=script&lang=js"
import style0 from "./BadgeButton.vue?vue&type=style&index=0&id=11ab8ae3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ab8ae3",
  null
  
)

export default component.exports